import type { IHeroBanner } from '~/components/widget/hero-banner/types'
import type { IWidgetAdsBlock } from '~/components/widget/ads-block'

export const heroBanner: IHeroBanner = {
  heading: 'common.bank_cards',
  text: 'page.cards.mocks.hero_banner.text',
  image: '/images/photostock/cards.png'
}

export const ctaBanner: IWidgetAdsBlock = {
  heading: 'page.cards.mocks.cta_banner.heading',
  text: 'page.cards.mocks.cta_banner.text',
  subtext: 'page.cards.mocks.cta_banner.subtext',
  image: '/images/banks/bakai-logo.png',
  url: '/bank/bakai/cards/208',
  action: {
    type: 'internal'
  }
}

export default {
  heroBanner,
  ctaBanner
}
